import Footer from "./Footer";
import Header from "./Header";
import { images } from "../../common/Images";
import "../../styles/Contact.css";
import { ApiCall, Colors,Web_url } from "../../common/Const";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import String from "../../lang/String";


function Contact() {
    const [firstname, setFirstname] = useState(false);
    const [lastname, setLastname] = useState(false);
    const [email, setEmail] = useState(false);
    const [phone, setPhone] = useState(false);
    const [comment, setComment] = useState(false);
    const [err, setErr] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [emailValue, setEmailValue] = useState('');
    const [phoneValue, setPhoneValue] = useState('');
    const [commentValue, setCommentValue] = useState('');
    const [submit, setSubmit] = useState(false);
    const [sendbtn, setSendbtn] = useState(false);

    const [contactError, setContactError] = useState({ firstname_error: "", lastname_error: "", email_error: "", phonenumber_error: "", comment_error: "" })


    const onSubmitHandler = (e) => {
        setErr(true)
        e.preventDefault();
        let lastAtPos = e.target.email.value.lastIndexOf('@');
        let lastDotPos = e.target.email.value.lastIndexOf('.');
        const reg = /^[0-9\b]+$/;
        if (e.target.first_name.value === '') {
            setContactError(prevError => ({ ...prevError, 'firstname_error': String.contact.first_required }))
            setFirstname(true);
        }
        // else if (e.target.first_name.value.length < 8) {
        //     setContactError(prevError => ({ ...prevError, 'firstname_error': String.contact.first_min }))
        //     setFirstname(true);
        // }
        else {
            setFirstname(false);
        }
        if (e.target.last_name.value === '') {
            setContactError(prevError => ({ ...prevError, 'lastname_error': String.contact.last_required }))
            setLastname(true);
        }
        else {
            setLastname(false);
        }
        if (e.target.email.value === '') {
            setContactError(prevError => ({ ...prevError, 'email_error': String.contact.enter_email }))
            setEmail(true);
        }
        else if (!(lastAtPos < lastDotPos && lastAtPos > 0 && e.target.email.value.indexOf('@@') === -1 && lastDotPos > 2)) {
            setContactError(prevError => ({ ...prevError, 'email_error': String.contact.valid_email }))
            setEmail(true);
        }
        else {
            setEmail(false);
        }
        if (e.target.phone.value === '') {
            setContactError(prevError => ({ ...prevError, 'phonenumber_error': String.contact.phone_requried }))
            setPhone(true);
        }
        else if (reg.test(e.target.phone.value) === false) {
            setContactError(prevError => ({ ...prevError, 'phonenumber_error': String.contact.phone_valid }))
            setPhone(true);
        }
        else if (e.target.phone.value.length < 10) {
            setContactError(prevError => ({ ...prevError, 'phonenumber_error': String.contact.phone_min }))
            setPhone(true);

        }
        else if (e.target.phone.value.length > 13) {
            setContactError(prevError => ({ ...prevError, 'phonenumber_error': String.contact.phone_max }))
            setPhone(true);
        }
        else {
            setPhone(false);
        }
        if (e.target.comment.value === '') {
            setContactError(prevError => ({ ...prevError, 'comment_error': String.contact.message_required }))
            setComment(true);
        }
        else if (e.target.comment.value.length < 10) {
            setContactError(prevError => ({ ...prevError, 'comment_error': String.contact.message_min }))
            setComment(true);
        }
        else {
            setComment(false);
        }
        setFirstName(e.target.first_name.value);
        setLastName(e.target.last_name.value);
        setEmailValue(e.target.email.value);
        setPhoneValue(e.target.phone.value);
        setCommentValue(e.target.comment.value);
        setSubmit(!submit)
    }
    useEffect(() => {
        if (err) {
            if ((firstname === false) && (lastname === false) && (email === false) && (phone === false) && (comment === false)) {
                setSendbtn(true);
                ApiCall('contactUs', {
                    first_name: firstName,
                    last_name: lastName,
                    email: emailValue,
                    phone: phoneValue,
                    comment: commentValue
                }).then((data) => {
                    setSendbtn(false);
                    if (data.message === "Success.") {
                        document.getElementById("contact-form").reset();
                        setFirstName('');
                        setLastName('');
                        setEmailValue('');
                        setPhoneValue('');
                        setCommentValue('');
                        toast.success('Message Sent Successfully', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                    }
                    else {
                        setSendbtn(false);
                        toast.error('Request Failed, try again!', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                    }
                }).catch((err) => {
                    setSendbtn(false);
                    toast.error('Request Failed, try again!', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                });
            }
        }
    }, [submit])
    return (
        <>
            <Header make={true} />
            <div className="container-fluid p-0">
                <div className="con-banner-img d-flex flex-column justify-content-end img-fluid" style={{
                    backgroundImage: `url(${images.about_main})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    width: "100%",
                    backgroundPosition: "top center",
                }}>
                    <div className="container">
                        <div className="row mb-4">
                            <div className="col-lg-4 col-sm-8 col-10 contact">
                                <h1 className="contact-head">Contact Us</h1>
                                <p className="contact-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur quis elit bibendum, posuere velit nec, placerat magna. Class aptent taciti sociosqu ad litora torquent per conubia nostra per conubia nostra.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="contact-back pt-5 pb-5 p-3">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-5 col-md-5 col-sm-5 col-12  con-col">
                            <h3 className="contact-title">Contact Info</h3>
                            <div className="d-flex contact-info">
                                <img src={images.locationImg} alt="fb" width="25px" height="25px"></img>
                                <p className="contact-addr">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur quis elit bibendum.</p>
                            </div>
                            <div className="d-flex mt-3 contact-info">
                                <img src={images.mailImg} alt="fb" width="25px" height="25px"></img>
                                <p className="contact-mail">Lorem@yopmail.com</p>
                            </div>
                            <div className="d-flex mt-3 contact-info">
                                <img src={images.phoneImg} alt="fb" width="25px" height="25px"></img>
                                <p className="contact-num">+91 9987876676</p>
                            </div>
                            <div className="d-flex mt-5 contact-info">
                            <a href="https://www.facebook.com/" target="blank"><img src={images.fb} alt="fb" width="32px" height="32px"></img></a>
                            <a href="https://twitter.com/" target="blank"><img src={images.tw} alt="fb" width="32px" height="32px" className="tw"></img></a>
                            <a href="https://www.instagram.com/" target="blank"> <img src={images.insta} alt="fb" width="32px" height="32px" className="insta"></img></a>
                            <a href={Web_url.web_url} target="blank"><img src={images.web} alt="fb" width="32px" height="32px" className="web"></img></a>
                            </div>
                        </div>
                    </div>
                </div>
                <form id="contact-form" onSubmit={onSubmitHandler}>
                    <div className="container">
                        <div className="row  justify-content-md-end con-col2">
                            <div className="col-xxl-8 col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 con-col1">
                                <div className="row justify-content-md-end">

                                    <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 con-col4">
                                        <h3 className="send-title">Send Message</h3>
                                        <div className="row justify-content-start mt-4">
                                            <div className="col-sm-6 col-12">
                                                <div className="form-group">
                                                    <label for="" className="first-label">First Name</label>
                                                    <input type="text"
                                                        className="contact-first" name="first_name" id="contact-first" aria-describedby="helpId" placeholder="First Name" autoComplete="off" />
                                                    <div className="err" style={{ display: firstname ? 'block' : 'none' }}>{contactError.firstname_error}</div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-12">
                                                <div className="form-group">
                                                    <label for="" className="last-label">Last Name</label>
                                                    <input type="text"
                                                        className="contact-first" name="last_name" id="contact-last" aria-describedby="helpId" placeholder="Last Name" autoComplete="off" />
                                                    <div className="err" style={{ display: lastname ? 'block' : 'none' }}>{contactError.lastname_error}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col-sm-6 col-12">
                                                <div className="form-group">
                                                    <input type="text"
                                                        className="contact-first" name="email" id="contact-email" aria-describedby="helpId" placeholder="Email Address" autoComplete="off" />
                                                    <div className="err" style={{ display: email ? 'block' : 'none' }}>{contactError.email_error}</div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 col-12">
                                                <div className="form-group">
                                                    <input type="text"
                                                        className="contact-mob" name="phone" id="contact-mob" aria-describedby="helpId" placeholder="Mobile Number" autoComplete="off" />
                                                    <div className="err" style={{ display: phone ? 'block' : 'none' }}>{contactError.phonenumber_error}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-4 col-12">
                                            <div className="form-group">
                                                <label for="exampleFormControlTextarea1" className="contact-label">Write your message here</label>
                                                <textarea className="contact-first contact-msg" name="comment" rows="4" id="contact-msg" autoComplete="off"></textarea>
                                                <div className="err" style={{ display: comment ? 'block' : 'none' }}>{contactError.comment_error}</div>
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col-6">
                                                <button
                                                    type="submit"
                                                    className="btn show-btn py-1 px-5 mt-2 contact-send"
                                                    style={{ color: Colors.white_color, backgroundColor: Colors.Base_color }}
                                                    disabled={sendbtn}
                                                >{!sendbtn ? "Send" : "Loading..."}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <ToastContainer />

            <Footer />
        </>
    );
}
export default Contact;